<template>
    <div>
        <div class="row">
            <div v-if="permission.market_bill_view" class="col-4">
                <h2 class="decorated"><span>মার্কেট রিপোর্ট</span></h2>
                <div class="card">
                    <div class="card-body">
                        <ul>
                            <li>১. <a href="/report/market-application">মার্কেট আবেদন</a></li>
                            <li>২. <a href="/report/market-bill">মার্কেট বিল</a></li>
                            <li>৩. <a href="/report/market-leadger">মার্কেট লেজার</a></li>
                            <li>৪. <a href="/report/market-collection-rate-monthly">একনজরে বিভিন্ন মাসে আদায়ের হার</a></li>
                            <li>৫. <a href="/report/market-collection-rate-yearly">বাৎসরিক আদায়ের হার</a></li>
                            <li>৬. <a href="/report/market-demand-calculation">মার্কেটের দাবি, আদায় ও আদায়ের হার</a></li>
                            <li>৭. <a href="/report/market-wise-shop">মার্কেট অনুসারে দোকানের সংখ্যা</a></li>
                            <li>৮. <a href="/report/market-wise-demand-summary">বিভিন্ন মার্কেটে দাবির রিপোর্ট (সামারী)</a></li>
                            <li>৯. <a href="/report/market-wise-demand-details">বিভিন্ন মার্কেটে দাবির রিপোর্ট (বিস্তারিত)</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-if="permission.water_bill_view" class="col-4">
                <h2 class="decorated"><span>পানি রিপোর্ট</span></h2>
                <div class="card">
                    <div class="card-body">
                        <ul>
                            <li>১. <a href="/report/water-bill">পানির বিল</a></li>
                            <li>২. <a href="/report/water-all-grahok">গ্রাহকের তালিকা</a></li>
                            <li>৩. <a href="/report/water-new-grahok">নতুন গ্রাহকের তালিকা</a></li>
                            <li>৪. <a href="/report/water-applicant-details">গ্রাহকের বিস্তারিত তথ্য</a></li>
                            <li>৫. <a href="/report/water-bank-wise-collections">ব্যাংক অনুসারে আদায়ের রিপোর্ট</a></li>
                            <li>৬. <a href="/report/water-all-demanad-collection-reports">গ্রাহকের ডিমান্ড ও আদায় রিপোর্ট</a></li>
                            <li>৭. <a href="/report/water-grahok-leadger">গ্রাহক লেজার</a></li>
                            <li>৮. <a href="/report/water-connection-fee-report">সংযোগ ফী আদায় রিপোর্ট</a></li>
                            <li>৯. <a href="/report/water-dia-change-report">গ্রাহকের ডায়া ও ধরন পরিবর্তনের রিপোর্ট</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-if="permission.market_bill_view" class="col-4">
                <h2 class="decorated"><span>অন্যান্য লিজ রিপোর্ট</span></h2>
                <div class="card">
                    <div class="card-body">
                        <ul>
                            <li>১. <a href="/report/other-lease-application">লিজ আবেদন</a></li>
                            <li>২. <a href="/report/other-lease-bill">লিজ বিল</a></li>
                            <li>৩. <a href="/report/other-lease-leadger">লিজ লেজার</a></li>
                            <li>৪. <a href="/report/other-lease-collection-rate">বাৎসরিক আদায়ের হার</a></li>
                            <li>৫. <a href="/report/other-lease/demand-calculation">লিজের দাবি, আদায় ও আদায়ের হার</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <h2 class="decorated"><span>অন্যান্য রিপোর্ট</span></h2>
                <div class="card">
                    <div class="card-body">
                        <ul>
                            <li v-if="permission.citizen_view">১. <a href="/report/citizen">সিটিজেন</a></li>
                            <li v-if="permission.citizen_view">২. <a href="/report/bank-reports">ব্যাংক রিপোর্ট</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
    data(){
        return {
            permission:'',
        }
    },
    methods:{
        allRole(){
            this.$store.dispatch('ALL_USER_ROLE')
        },
        getPermission(){
            this.$store.dispatch('ALL_USER_ROLE2')
            .then(response=>{
                this.permission = response.data.permission
            })
        }
    },
    mounted(){
        this.allRole()
        this.getPermission()
    },
    computed: {
        ...mapGetters(["user_roles"]),
    },

}
</script>


<style scoped>
.card{ padding: 20px; min-height: 192px; background: whitesmoke;}
.card-body{ padding: 0;}
.card-body ul{ margin: 0; padding:0;}
.card-body ul li{ list-style: none; display: block;color: teal; font-size: 16px; margin-bottom: 10px; font-weight: bold;}
.card-body ul li,.card-body ul li a{font-family: 'Hind Siliguri Light'; line-height: 22px; font-weight: bold;}
.card-body ul li a{ color: teal;font-size: 16px;}
.card-body ul li:last-child{margin-bottom: 0px;}
.decorated{overflow: hidden;}
.decorated > span{
    position: relative;
    display: inline-block;
    font-family: 'Hind Siliguri Light';
    font-size: 16px; font-weight: bold;
}
.decorated > span:after{
    content: '';
    position: absolute;
    top: 50%;
    border-bottom: 1px solid;
    width: 100vw;
    margin: 0 10px;
}
.decorated > span:before{
    right: 100%;
}
</style>
